import { createGlobalStyle } from 'styled-components';

export const MainColor = '#007AFF';
export const MainColorText = '#ffffff';

export const GlobalStyle = createGlobalStyle`
    @import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.8/dist/web/static/pretendard.css");
    @import url(https://db.onlinewebfonts.com/c/d05c19ccecf7003d248c60ffd6b5e8f7?family=Binance+PLEX);
    @import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    @font-face {
        font-family: "Binance PLEX";
        src: url("https://db.onlinewebfonts.com/t/d05c19ccecf7003d248c60ffd6b5e8f7.eot");
        src: url("https://db.onlinewebfonts.com/t/d05c19ccecf7003d248c60ffd6b5e8f7.eot?#iefix")format("embedded-opentype"),
        url("https://db.onlinewebfonts.com/t/d05c19ccecf7003d248c60ffd6b5e8f7.woff2")format("woff2"),
        url("https://db.onlinewebfonts.com/t/d05c19ccecf7003d248c60ffd6b5e8f7.woff")format("woff"),
        url("https://db.onlinewebfonts.com/t/d05c19ccecf7003d248c60ffd6b5e8f7.ttf")format("truetype"),
        url("https://db.onlinewebfonts.com/t/d05c19ccecf7003d248c60ffd6b5e8f7.svg#Binance PLEX")format("svg");
    }

    @font-face {
    font-family: 'Paperlogy-4Regular';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/2408-3@1.0/Paperlogy-4Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    }

    @font-face {
        font-family: 'Paperlogy-8ExtraBold';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/2408-3@1.0/Paperlogy-8ExtraBold.woff2') format('woff2');
        font-weight: 800;
        font-style: normal;
    }

    @font-face {
        font-family: 'Pretendard-Regular';
        src: url('https://fastly.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff') format('woff');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'SBAggroB';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SBAggroB.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'CookieRun-Regular';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/CookieRun-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'GongGothicMedium';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_20-10@1.0/GongGothicMedium.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: '양진체';
        src: url('https://fastly.jsdelivr.net/gh/supernovice-lab/font@0.9/yangjin.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'YeongwolTTF-Regular';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/2507-2@1.0/YeongwolTTF-Regular.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Danjo-bold-Regular';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2307-1@1.1/Danjo-bold-Regular.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'ChosunGs';
        src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@1.0/ChosunGs.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    html,
    body,
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    i,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark,
    audio,
    video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }

    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
        display: block;
    }

    body {
        width: 100vw;
        line-height: 1;
        font-family: "Urbanist", "Binance PLEX","Pretendard", "Arial", "Helvetica Neue", "Helvetica", sans-serif !important;
        background-color: ${({ theme }) => (theme as any).body};
    }

    ol,
    ul {
        list-style: none;
    }

    a {
        color: inherit;
        text-decoration: none;
    }

    blockquote,
    q {
        quotes: none;
    }

    blockquote:before,
    blockquote:after,
    q:before,
    q:after {
        content: "";
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    button {
        cursor: pointer;
        border: none;
        outline: none;
        background: none;
    }

    a {
        text-decoration: none;
    }

    html,
    body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        overflow-x: hidden;
        scroll-behavior: smooth;
    }

    a {
        text-decoration: none;
        outline: none;
    }

    a:hover,
    a:active {
        text-decoration: none;
    }

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => (theme as any).COLORS?.scrollbarThumb || '#999'};
        border-radius: 4px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-corner,
    ::-webkit-resizer {
        background: ${({ theme }) => (theme as any).COLORS?.scrollbarTrack || '#333333'};
    }

    * {
        font-family: 'Urbanist', 'Binance PLEX', 'Spoqa Han Sans Neo', 'Roboto', 'sans-serif';
        box-sizing: border-box;
    }

    /* prevent bouncing */
    body {
        min-height: 100vh;
        overscroll-behavior: none; /* or overscroll-behavior: none; */
    }

    body > #root > div {
        min-height: 100vh;
    }

    html {
        font-size: 62.5%;
    }

    *:focus {
        outline: none;
    }

    input[type=checkbox] {
        background: transparent;
    }


    .warning {
        color: red;
        font-size: 13px;
        padding: 10px 5px;
    }

    .modalConfirm {
        font-size: 14px;
    }

    .modalConfirm h1 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    input:-webkit-autofill {
        -webkit-text-fill-color: #99f;
    }

    input:-webkit-autofill:focus {
        -webkit-text-fill-color: #999;
    }


    [data-rsbs-overlay],
    [data-rsbs-backdrop],
    [data-rsbs-root]:after {
        z-index: 1005 !important;
        -ms-scroll-chaining: none;
        overscroll-behavior: none;
        touch-action: none;
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
    }

    @media (max-width: 1400px) {


    }


    @keyframes flashgreen {
        20% {
            background-color: rgba(0, 0, 255, 0.5);
        }
    }


    @keyframes flashred {
        20% {
            background-color: rgba(255, 0, 0, 0.5);
        }
    }

    .mobile-tabs-dropdown-root {
        & .ant-dropdown-menu {
        background-color: ${({ theme }) => (theme as any).COLORS.tableBg};
        border-radius: 6px;
        border: 1px solid ${({ theme }) => (theme as any).COLORS.mobileTradeBorder};
        }
    }

    .tabledark {
        & .ant-card {
            background: #404040 !important;
            border: 0;
            color: #ffffff;
            border-radius: 0;
        }

        & .ant-tag {
            color: #ffffff;

        }

        & .ant-table {
            border-radius: 0;
            background: #000000 !important;
            color: #ffffff;
        }

        & .ant-table-container {
            border-start-start-radius: 0 !important;
            border-start-end-radius: 0 !important;
            background: transparent !important;
        }

        & .ant-table-header {
            border-radius: 0 !important;
            padding: 0;
            background: transparent !important;
        }

        & .ant-table-header::before {
            width: 0 !important;
        }

        & .ant-table-thead .ant-table-cell {
            border-radius: 0 !important;
            padding: 0;
            background: transparent !important;
            border-bottom: 1px solid #505050 !important;
            color: #ffffff;
            border: 0;
            box-shadow: none !important;
        }

        & .ant-table-header .ant-table-cell {
            border-radius: 0 !important;
            padding: 0;
            background: transparent !important;
            color: #ffffff;
            border: 0;
            box-shadow: none !important;
        }

        & .ant-table-thead .ant-table-cell::before {
            width: 0 !important;
        }

        & .ant-table-header .ant-table-cell::before {
            width: 0 !important;
        }

        & .ant-table-body .ant-table-cell {
            background: #000000 !important;
            color: #ffffff;
            border-bottom: 1px solid #505050 !important;
        }

        & .ant-table-row:hover .ant-table-cell {
            background: #000000 !important;
            color: #ffffff;
        }

        & .ant-table-footer {
            background: #000000 !important;
            color: #ffffff;
            border-radius: 0;
        }

        & .ant-pagination .ant-pagination-item a {
            background: #000000 !important;
            color: #ffffff;
        }

        & .ant-pagination li button {
            background: #000000 !important;
            color: #ffffff !important;
        }
    }

    .triggerdark {
        .ant-select-selection-item {
            color: #212121 !important;
        }
    }

    .triggerunDark {
        .ant-select-selection-item {
            color: #FFFFFF !important;
        }
    }

    .chartselectdart {
        & .ant-select-selector {
            background-color: #000000 !important;
            color: #ffffff !important;
        }
    }

    .chartselectlight {
        & .ant-select-selector {
            background-color: #000000 !important;
            color: #ffffff !important;
        }
    }

    /* Dark 모드 */
    .ovlist.dark input {
        color: #ffffff; /* 원하는 색상 */
    }

    /* Light 모드 */
    .ovlist.light input {
        color: #000000; /* 원하는 색상 */
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 8px;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        background: none;
        border-radius: 8px;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #dfdfdf;
        border-radius: 8px;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    .pc-content {
        display: flex !important;
    }

    .m-content {
        display: none !important;
    }

    @media (max-width: 1350px) {
        .pc-content {
            display: none !important;
        }

        .m-content {
            display: flex !important;
        }
    }

    /* Ant Design Message 커스텀 스타일 */
    .ant-message {
        z-index: 99000 !important;
        width: fit-content !important;
    }

    .ant-message .ant-message-notice-content {
        background: ${({ theme }) => theme.COLORS?.ModalBg || '#1f1f1f'} !important;
        border: 1px solid ${({ theme }) => theme.COLORS?.PrimaryBorder || '#3a3b3c'} !important;
        border-radius: 8px !important;
        padding: 12px 16px !important;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4) !important;
        backdrop-filter: blur(8px) !important;
        min-width: 300px !important;
    }

    .ant-message .ant-message-success .ant-message-notice-content .anticon,
    .ant-message .ant-message-success .anticon {
        color: #52c41a !important;
        font-size: 18px !important;
    }

    .ant-message .ant-message-error .ant-message-notice-content .anticon,
    .ant-message .ant-message-error .anticon {
        color: #ff4d4f !important;
        font-size: 18px !important;
    }

    .ant-message .ant-message-warning .ant-message-notice-content .anticon,
    .ant-message .ant-message-warning .anticon {
        color: #faad14 !important;
        font-size: 18px !important;
    }

    .ant-message .ant-message-info .ant-message-notice-content .anticon,
    .ant-message .ant-message-info .anticon {
        color: #1890ff !important;
        font-size: 18px !important;
    }

    .ant-message .ant-message-notice-content span,
    .ant-message .ant-message-notice-content .ant-message-custom-content {
        color: ${({ theme }) => theme.text || '#ffffff'} !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1.5 !important;
    }


    .p2pmodal .ant-modal-close-x {
        color: #000 !important;

    }

    .p2pmodal.dark .ant-modal-content, .p2pmodal.dark .ant-modal-header *, .p2pmodal.dark .ant-modal-body, .p2pmodal.dark .ant-modal-footer, .p2pmodal.dark .ant-modal-close-x {
        background-color: #191A19 !important;
        color: #ffffff !important;
    }


    .ant-table-cell {
        vertical-align: middle;
    }

    /* 크롬, 엣지, 사파리 등 Webkit 기반 브라우저 */
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type="number"] {
        -moz-appearance: textfield;
    }

    /* 모달관련 */
    .custom-modal .ant-modal-content {
        background-color: ${({ theme }) => theme.COLORS.ModalBg}; /* 원하는 배경색 */
        color: ${({ theme }) => theme.text}; /* 원하는 배경색 */
    }

    .custom-modal .ant-modal-body  {
        background-color: ${({ theme }) => theme.COLORS.ModalBg}; /* 원하는 배경색 */
    }

    .custom-modal .ant-modal-header {
        background-color: ${({ theme }) => theme.COLORS.ModalBg}; /* 헤더 색상 변경 */
    }

    .custom-modal .ant-modal-title {
        color: ${({ theme }) => theme.text};       /* 헤더 텍스트 색상 */
    }

    .custom-modal .ant-modal-close {
        color: ${({ theme }) => theme.text};       /* 헤더 텍스트 색상 */
    }

    /* ANT D Slider */
    .ant-slider {
        pointer-events: auto; /* 명시적으로 활성화 */
    }

    .ant-btn{
        box-shadow: none !important;
    }

    .adm-input-element {
        color: ${({ theme }) => theme.text};
    }

    /* 드롭다운 hover 스타일 */
    .react-tel-input .flag-dropdown .country-list .country:hover {
        background-color: #007AFF; /* 원하는 hover 배경색 */
        color: #ffffff;           /* 텍스트 색상 */
    }

    .react-tel-input .country-list .country.highlight {
        background-color: #007AFF; /* 원하는 hover 배경색 */
    }

    .ant-steps-item-wait .ant-steps-item-title {
        color: gray !important;
    }

    .custom-select-no-radius .ant-select-selector {
        border-radius: 0 !important;
    }

    .custom-select-no-radius .ant-picker {
        border-radius: 0 !important;
    }

    .ant-space-compact .ant-picker {
        border-radius: 0 !important;
    }

    .ant-divider {
      border-block-start: 1px solid ${({ theme }) => theme.COLORS.PrimaryBorder};
    }

    /* View Transition API - 테마 전환 애니메이션 */
    ::view-transition-old(root),
    ::view-transition-new(root) {
      animation-duration: 0.3s;
      animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }

    /* 크로스 페이드 효과 */
    ::view-transition-old(root) {
      animation-name: fade-out;
    }

    ::view-transition-new(root) {
      animation-name: fade-in;
    }

    @keyframes fade-out {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }

    @keyframes fade-in {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    /* View Transition API를 지원하지 않는 브라우저를 위한 폴백 */
    * {
      transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                  color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                  border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
`;
